import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"translate"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13 14H17M17 14H21M17 14V12.5M20 14C20 17.866 16.866 21 13 21M14.6736 17C15.7971 19.3649 18.2076 21 21 21M9 7.5V5C9 3.89543 8.10457 3 7 3H5C3.89543 3 3 3.89543 3 5V7.5M9 7.5V10M9 7.5H3M3 10V7.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M13 4.5H18C19.1046 4.5 20 5.39543 20 6.5V8M5 14V19C5 20.1046 5.89543 21 7 21H8.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Translate = Vue.extend<IconProps>({
  name: 'TranslateIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'translate',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Translate;
